import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { PageSection } from '../../../ContentfulTypes';
import {
  ErrorScreen,
  SectionWrapper,
  TryAgainButton,
  BladeTitle,
  BladeSubtitle,
  ImgWrapper,
  RobotImg,
} from './styles';

interface ReserveErrorProps {
  tryAgainHandler: () => void,
  reserveData: PageSection,
}

const ReserveError = ({ tryAgainHandler, reserveData }: ReserveErrorProps) => {
  // CREATE DATALAYER FOR GTM ANALYTICS
  useEffect(() => {
    // Create dataLayer object for GTM if it doesn't exist yet
    window.dataLayer = window.dataLayer || [];
    // Structure data to submit
    const phase4Data = {
      event: 'reservenow',
      reservePhase: 'phase 4 - error screen',
    };
    window.dataLayer.push(phase4Data);

    /* eslint-disable */
    //check if hj function exists
    window["hj"] =
      window["hj"] ||
      function () {
        (window["hj"].q = window["hj"].q || []).push(arguments);
      };
    //hj('trigger', 'phone_reservation');
    /* eslint-enable */
  }, []);

  // Reserve labels data
  const reserveLabelSection = reserveData.combinatorSectionItems?.find(
    (item) => item.contentful_id === '6Zd784HpNQHexTi3nCCaw3',
  );

  const reserveLabels = reserveLabelSection?.formFields?.reduce<Record<string, string | undefined>>(
    (obj, item) => {
      obj[item.contentful_id as string] = item.displayLabel;
      return obj;
    },
    {},
  ) || {};
  const imageSection = reserveData.combinatorSectionItems?.find((item) => item.contentful_id === '6LPZFQ7GT6IqjdK66aWe2v') || {};

  return (
    <ErrorScreen>
      <BladeTitle>
        {ReactHtmlParser(reserveLabels['5EBotkx2KnOVtnfzPcrXqD'])}
      </BladeTitle>
      <br />
      {/* ERROR IMAGE AND TEXT */}
      <SectionWrapper>
        <ImgWrapper>
          <RobotImg image={imageSection.foregroundImageDesktop || {}} />
        </ImgWrapper>
        <BladeSubtitle>
          {ReactHtmlParser(
            reserveLabels['3QIfraVMljQ1akFGwU7Tsv'],
          )}
        </BladeSubtitle>
      </SectionWrapper>
      {/* TRY AGAIN BUTTON */}
      <SectionWrapper id="tryAgainButton">
        <TryAgainButton onClick={tryAgainHandler}>
          {ReactHtmlParser(reserveLabels.a2vl4MjRhfymbXpyg0Pj0)}
        </TryAgainButton>
      </SectionWrapper>
    </ErrorScreen>
  );
};

export default ReserveError;
